import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from 'chart.js';
import '../styles/transactions.css';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

const ChartInfo = ({ transactions }) => {
    // Filter out trading transactions
    const filteredTransactions = transactions.filter(transaction => 
        transaction.account !== 'Trading'
    );

    // Data processing using filtered transactions
    const creditData = filteredTransactions.map(transaction => 
        transaction.type === 'credit' ? transaction.amount : 0
    );
    const debitData = filteredTransactions.map(transaction => 
        transaction.type === 'debit' ? transaction.amount : 0
    );
    const labels = filteredTransactions.map(() => '');

    // Chart.js data structure
    const data = {
        labels,
        datasets: [
            {
                label: 'Credits',
                data: creditData,
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                fill: true,
            },
            {
                label: 'Debits',
                data: debitData,
                borderColor: 'rgba(255, 99, 132, 1)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                fill: true,
            },
        ],
    };

    // Chart.js options
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                ticks: {
                    display: false, 
                },
                grid: {
                    display: false, 
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Amount',
                },
            },
        },
        plugins: {
            legend: {
                position: 'top',
            },
        },
    };

    return (
        <div className="chart-container">
            <h3 className='black-title'>Transaction Overview</h3>
            <div style={{ width: '90%', height: '100%' }}> 
                <Line data={data} options={options} />
            </div>
        </div>
    );
};

export default ChartInfo;